import Converter from './Converter';
import { shortLanguages } from 'services/locale';
import { CasinoType, ICasinoProviderConfigurationItem } from 'modules/Casino/types/configuration';
import { projectName } from 'modules/Casino/utils/slots';
import { parseCookies } from '../../utils/parseCookies';
import { QueryTypes } from 'modules/Casino/types/enums/api';

const converter = new Converter();

export const config: ICasinoProviderConfigurationItem<Converter> = {
  type: CasinoType.slots,
  authRequired: true,
  gameListUrl: 'outcome/v1/game_list',
  converter,
  gameListUrlData: {
    getHeaders: () => ({
      'Content-Type': 'application/json',
      headers: { 'x-partner-name': projectName },
    }),
  },
  sessionUrlData: {
    url: 'outcome/v1/session',
    method: QueryTypes.GET,
    converter: converter.convertGameUrl,
    getBody: params => ({
      game_id: params.gameId,
    }),
    getHeaders: () => ({
      headers: {
        'x-partner-authorization': parseCookies(),
        'x-partner-name': projectName,
      },
    }),
  },
  multiProvider: true,
};
